export const onAddDialogDone = entry => ({
  widget: 'entries',
  type: 'onAddDialogDone',
  payload: { entry },
})



// WEBPACK FOOTER //
// ./src/entries/actions/onAddDialogDone.js